import React from "react";
import PracticeLeaderShip from "./PracticeLeaderShip";
import "./LeaderShip.css";
import { leadershipData, otherLeaders } from "./LeadershipData";

function LeaderShip() {
  return (
    <div>
      <PracticeLeaderShip
        leadershipData={leadershipData}
        otherLeaders={otherLeaders}
      />
    </div>
  );
}

export default LeaderShip;
